module.exports = __webpack_public_path__ + "static/img/icon01.24b231a3.svg";